import { render } from "./Dashboard2.vue?vue&type=template&id=eadf57e2&ts=true"
import script from "./Dashboard2.vue?vue&type=script&lang=ts"
export * from "./Dashboard2.vue?vue&type=script&lang=ts"

import "./Dashboard2.vue?vue&type=style&index=0&id=eadf57e2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__